import { selectorAppContext } from '@cancellation-portal/modules/app-context/duck';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({ appContext: selectorAppContext(state) });
export const withAppContext = connect(mapStateToProps);
